import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// ============ INTERFACE ============

export interface FlowStateInterface {
  flowType: 'web' | 'agent';
}

// ============ INIT STATE ============

const initialState: FlowStateInterface = {
  flowType: 'agent'
};

// ========= SLICE ==========

export const flowSlice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    setFlowType: (state: FlowStateInterface, action: PayloadAction<'web' | 'agent'>) => {
      state.flowType = action.payload;
    },
  }
})

export const { setFlowType } = flowSlice.actions;

export default flowSlice.reducer;